export default __webpack_public_path__ + "img/pin.cb1c2481.svg";